// extracted by mini-css-extract-plugin
export default {"benefits":"benefits_benefits__cU5ni","benefit_cards":"benefits_benefit_cards__jFvSZ","benefit_card":"benefits_benefit_card__Xd+Zt"};